$(document).ready(function(){
//home page small image slider
$(document).on("mouseover",".itg_card_tab P", function(){
      $(".itg_card_tab P").removeClass('active');
      $(this).addClass('active');
      var value_1 = $(this).attr("DataTab");     
     $(".tab_image").each(function(){
      var value_2 = $(this).attr("DataContent");
       if(value_1 == value_2){
         $(this).addClass("image-active")
       }
       else{
         $(this).removeClass("image-active")
       }
     })
   });
//Announcement bar slider 
  // $('.itg_announcement_bar_slider').slick({
  //   slidesToScroll: 1,
  //   arrows: false,
  //   autoplay:true,
  //   autoplaySpeed:1500,
  //   dots: false,
  //   vertical: true,
  //   verticalSwiping: true
  // });
  var mySwiper = new Swiper ('.itg_announcement_bar_slider', {
    direction: 'vertical',
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
});
   //Featured Collection slider
//   $('.itg_featured_collection_slider').slick({
//   infinite: false,
//   slidesToShow: 3.5,
//   slidesToScroll: 1,
//   dots: false,
//   arrows: true,
//   prevArrow: '<button class="slick-prev pull-left carousel-btns slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.5 12.5 15 20l7.5 7.5"/></svg></button>',
//   nextArrow: '<button class="slick-next pull-right carousel-btns slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 12.5 25 20l-7.5 7.5"/></svg></button>',
//   responsive: [
//        {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3.1,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 750,
//         settings: {
//           slidesToShow: 2.1,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ] 
// });


  // IMAGE WITH SLIDER
  var swiper = new Swiper(".custom_image_width_slider_head ", {
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
  });

  // CUSTOM MULTICOLUMN
  // var swiper = new Swiper(".custom_multicolumn_head", {
  //   slidesPerView: 3,
  //   spaceBetween: 30,
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true,
  //   },
  //   breakpoints: {
  //       768: {
  //         slidesPerView: 1,         
  //       }
  //     },
  // });

    var swiper = new Swiper(".custom_multicolumn_head", {
      slidesPerView: 3,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },    
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100
      },
      breakpoints: {
        1024:{
          slidesPerView: 3,          
        },
        768: {
          slidesPerView: 2,         
        },
         0: {
          slidesPerView: 1,
        }
      },
    });

  var swiper = new Swiper(".custom_image_with_text_image", {
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
  });
  
  var swiper = new Swiper(".itg_featured_collection_slider", {
      spaceBetween: 0,
      loop: false,
      //freeMode: true,
      navigation: {
        nextEl: '.swiper-button-next.itg-swiper-arrow',
        prevEl: '.swiper-button-prev.itg-swiper-arrow'
      },      
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100
      },
      breakpoints: {
        1024:{
          slidesPerView: 3.5,          
        },
        768: {
          slidesPerView: 2,         
        },
         480: {
          slidesPerView: 1,
        }
      },
    });
  //collection list section slider
//   $('.itg_collection_slider').slick({
//   infinite: false,
//   slidesToShow: 4.1,
//   slidesToScroll: 1,
//   dots: false,
//   arrows: true,
//   prevArrow: '<button class="slick-prev pull-left carousel-btns slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.5 12.5 15 20l7.5 7.5"/></svg></button>',
//   nextArrow: '<button class="slick-next pull-right carousel-btns slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 12.5 25 20l-7.5 7.5"/></svg></button>',
//   responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3.1,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 750,
//         settings: {
//           slidesToShow: 2.1,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ] 
// });
var window_width = $(window).width();

  var $swiperSelector = $('.itg_collection_slider.swiper-container');

$swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass('swiper-slider-' + index);
    
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : true;
    var loop = $this.data('loop') ? $this.data('loop') : false; 

    var swiper = new Swiper('.swiper-slider-' + index, {
      direction: 'horizontal',
      loop: loop,
      allowTouchMove: true,
      freeMode: freeMode,
      spaceBetween: 10,
      breakpoints: {
        1024: {
          slidesPerView: 5,
        },
        768:{
          slidesPerView: 3,
          allowTouchMove: true,
        },
        480: {
           slidesPerView: 1.2,
           allowTouchMove: true,
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100
      }
   });
});


//loyalty program slider
var swiper = new Swiper(".itg_loy_slider", {
  //effect: "fade",
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 100
  },
});

//Custom banner slider 
var swiper = new Swiper(".itg_banner_slider", {
  //effect: "fade",
  // autoplay: {
  //   delay: 2500,
  //   disableOnInteraction: false,
  // },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 100
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});  
  

  $('.itg_megamenu').click(function(){
    $(this).closest('.site-nav__details').removeAttr('open');
  });


if (window.matchMedia("(max-width: 768px)").matches) {
  var swiper = new Swiper(".itg_collection_list", {
      spaceBetween: 10,
      loop: false,
      slidesPerView: 2,
      //freeMode: true,    
      scrollbar: {
        el: '.swiper-scrollbar1',
        draggable: true,
        dragSize: 100
      },
      breakpoints: {
        768: {
          slidesPerView: 2        
        }
      }
    });
}


//add class on scroll
$(window).scroll(function() {
  if ($(this).scrollTop() > 200){
    $('.announcement-bar').addClass("itg_fixed");
  } else {
    $('.announcement-bar').removeClass("itg_fixed");
  }
});
});

// $(document).load($(window).bind("resize", checkPosition));
// function checkPosition(){
//    if($(window).width() >= 767){
//      var swiper = new Swiper(".itg_collection_list", {
//       spaceBetween: 0,
//       loop: false,
//       //freeMode: true,    
//       scrollbar: {
//         el: '.swiper-scrollbar1',
//         draggable: true,
//         dragSize: 100
//       },
//       breakpoints: {
//         768: {
//           slidesPerView: 2,         
//         },
//          480: {
//           slidesPerView: 1,
//         }
//       },
//     });
//    }
// }


//Show sahre data on product page 
$(document).on('click', '.itg_share_icon', function(){
  $('.itg_show_share_icon').toggleClass('open')
});

//Faq page search option
 $(document).on('change keyup paste', '.faqAccordianBanner_search input#search', function(){
    // console.log('key');
    var searchtermNF = $(this).val();
    var searchTerm = $(this).val().toUpperCase();
    // console.log(searchTerm);
    if ( searchTerm == "" ) {
      $('.faqAccordianError_message').hide();
      $('.itg_faq_accordion.itg_faq_heading').show();
      $('.itg_fqa_question').show();
      return;
    }
    $(".itg_fqa_question").each(function(){
      var accordianText = $(this).find('.itg_faq_data button.collapsible-trigger span.itg_accordion_title').text().toUpperCase();
      // console.log('accordian Text----' + accordianText)
      if  ( accordianText.indexOf(searchTerm) != -1) {
        $(this).show();
        $(this).addClass('searchMatched');
        $('.itg_faq_accordion.itg_faq_heading').hide();
        $('.itg_faq_accordion.itg_faq_heading:first').show();
      }else{
        $(this).hide();
        $(this).removeClass('searchMatched');
      }

      var MatchedLength = $('.itg_fqa_question.searchMatched').length;
      // console.log(MatchedLength)
      if(MatchedLength >= 1) {
        $('.faqAccordianError_message').hide();
      }else{
        $('.faqAccordianError_message span').text(searchtermNF);
        $('.faqAccordianError_message').show();
        $('.itg_faq_accordion.itg_faq_heading').hide();
      }
    });
  });






//custom cursor
// const cursor = document.querySelector('.cursor');

// document.addEventListener('mousemove', e => {
//     cursor.setAttribute("style", "top: " + (e.pageY - 10) + "px; left: " + (e.pageX - 10) + "px;")
// });

// document.addEventListener('click', e => {
//     cursor.classList.add("expand");
//     setTimeout(() => {
//         cursor.classList.remove("expand");
//     }, 500);
// });

let clientX = -100;
let clientY = -100;
const innerCursor = document.querySelector(".cursor--small");

const initCursor = () => {

  document.addEventListener("mousemove", e => {
    clientX = e.clientX;
    clientY = e.clientY;
  });
  
  
  // const render = () => {
  //   innerCursor.style.transform = `translate(${clientX}px, ${clientY}px)`;
    
  //   requestAnimationFrame(render);
  // };
  // requestAnimationFrame(render);
};

initCursor();
let lastX = 0;
let lastY = 0;
let isStuck = false;
let showCursor = false;
let group, stuckX, stuckY, fillOuterCursor;

const initCanvas = () => {
  const canvas = document.querySelector(".cursor--canvas");
  const shapeBounds = {
    width: 75,
    height: 75
  };
  paper.setup(canvas);
  const strokeColor = "rgba(0, 0, 0, 0.5)";
  const strokeWidth = 1;
  const segments = 8;
  //const radius = 25;
  const radius = 12;
  
  const noiseScale = 150; // speed
  const noiseRange = 4; // range of distortion
  let isNoisy = false; // state
  
  const polygon = new paper.Path.RegularPolygon(
    new paper.Point(0, 0),
    segments,
    radius
  );
  polygon.strokeColor = strokeColor;
  polygon.strokeWidth = strokeWidth;
  polygon.smooth();
  group = new paper.Group([polygon]);
  group.applyMatrix = false;
  
  const noiseObjects = polygon.segments.map(() => new SimplexNoise());
  let bigCoordinates = [];
  
  
  const lerp = (a, b, n) => {
    return (1 - n) * a + n * b;
  };
  const map = (value, in_min, in_max, out_min, out_max) => {
    return (
      ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
    );
  };
  
  paper.view.onFrame = event => {
   
    lastX = lerp(lastX, clientX, 0.2);
    lastY = lerp(lastY, clientY, 0.2);
    group.position = new paper.Point(lastX, lastY);
  }
}

// initCanvas();
const initHovers = () => {

  const handleMouseEnter = e => {
    const navItem = e.currentTarget;
    const navItemBox = navItem.getBoundingClientRect();
    stuckX = Math.round(navItemBox.left + navItemBox.width / 2);
    stuckY = Math.round(navItemBox.top + navItemBox.height / 2);
    isStuck = true;
  };
  
  const handleMouseLeave = () => {
    isStuck = false;
  };
  
  //Event listeners
  const linkItems = document.querySelectorAll(".link");
  linkItems.forEach(item => {
    item.addEventListener("mouseenter", handleMouseEnter);
    item.addEventListener("mouseleave", handleMouseLeave);
  });
};

initHovers();

//Find your size page 
  var opt1 = document.getElementById('option-1');
  var opt2 = document.getElementById('option-2');
  var dtImage = document.getElementById('dt-image')
  var mbImage = document.getElementById('mb-image')

  function toggleIn() {
    console.log(opt1.dataset.toggle);
    opt1.style.fontWeight = "600";
    opt2.style.fontWeight = "400";

    if ((window.innerWidth || document.documentElement.clientWidth) > 769) {
      dtImage.srcset = "https://cdn.shopify.com/s/files/1/1365/7915/files/size-chart-desktop.png?v=1663865318";
    } else {
      mbImage.srcset = 'https://cdn.shopify.com/s/files/1/1365/7915/files/size-chart-mobile.png?v=1663865332';

    }

  }


  function toggleCm() {
    opt2.style.fontWeight = "600";
    opt1.style.fontWeight = "400";
    if ((window.innerWidth || document.documentElement.clientWidth) > 769) {
      dtImage.srcset =
        'https://cdn.shopify.com/s/files/1/1365/7915/files/desktop-cm_9e9069a9-60b8-4614-aecd-b860d9ce04cc.png?v=1663875210';
    } else {
      mbImage.srcset = 'https://cdn.shopify.com/s/files/1/1365/7915/files/mobile_cm.png?v=1663873928';

    }

  }

// function searchDrawer() {
//   let searchIcon = document.querySelector(".search-mobile-filter");
//   let searchIcondesktop = document.querySelector(".desktop-search");
//   let mobileSearchdrawer = document.querySelector('.mobile-drawer-search');
//   let closeMobilesearch = document.querySelector('.close-wrapper-icon');
//   let bodyElement = document.body;
//   if (searchIcon && mobileSearchdrawer && bodyElement) {
//     searchIcon.addEventListener("click", function () {
//       mobileSearchdrawer.classList.add('active-drawer');
//       bodyElement.classList.add('overflow-hidden');
//     });
//   }
//   if(closeMobilesearch && mobileSearchdrawer && bodyElement){
//     closeMobilesearch.addEventListener("click", function () {
//       mobileSearchdrawer.classList.remove('active-drawer');
//       bodyElement.classList.remove('overflow-hidden');
//     });
//   }
//   if (searchIcondesktop && mobileSearchdrawer && bodyElement) {
//     searchIcondesktop.addEventListener("click", function () {
//       mobileSearchdrawer.classList.add('active-drawer');
//       bodyElement.classList.add('overflow-hidden');
//     });
//   }
// }
function searchDrawer() {
  let searchTriggers = document.querySelectorAll(".search-mobile-filter, .desktop-search");
  let mobileSearchdrawer = document.querySelector('#MobileSearchDrawer');
  let closeMobilesearch = mobileSearchdrawer ? mobileSearchdrawer.querySelectorAll('.close-wrapper-icon') : [];
  let searchInput = mobileSearchdrawer ? mobileSearchdrawer.querySelector('input[type="search"]') : null;
  let bodyElement = document.body;
  let lastSearchTrigger = null;

  if (!searchTriggers.length || !mobileSearchdrawer || !bodyElement) {
    return;
  }

  function syncSearchDrawerState(open) {
    mobileSearchdrawer.classList.toggle('active-drawer', open);
    mobileSearchdrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    mobileSearchdrawer.toggleAttribute('inert', !open);
    bodyElement.classList.toggle('overflow-hidden', open);

    searchTriggers.forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', open && trigger === lastSearchTrigger ? 'true' : 'false');
    });

    if (open) {
      window.setTimeout(function () {
        if (searchInput) {
          searchInput.focus();
        }
      }, 50);
    } else if (lastSearchTrigger) {
      lastSearchTrigger.focus();
    }
  }

  searchTriggers.forEach(function (trigger) {
    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      lastSearchTrigger = trigger;
      syncSearchDrawerState(true);
    });
  });

  closeMobilesearch.forEach(function (closeButton) {
    closeButton.addEventListener("click", function () {
      syncSearchDrawerState(false);
    });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === 'Escape' && mobileSearchdrawer.classList.contains('active-drawer')) {
      syncSearchDrawerState(false);
    }
  });

  syncSearchDrawerState(mobileSearchdrawer.classList.contains('active-drawer'));
}
document.addEventListener("DOMContentLoaded", function () {
  searchDrawer();
});

function my_code(){
  var a = document.querySelector('a[href="https://www.naniswimwear.com/products/coastal-hybrid-explorer-short?_pos=1&_psq=coastal-h&_ss=e&_v=1.0"]');
  if (a) {
    a.setAttribute('href', '/')
  }
}

window.addEventListener('load', function() {
  setTimeout(my_code, 1000);
});


      document.addEventListener("DOMContentLoaded", function () {
        const swimwearHeaders = document.querySelectorAll('.SiteHeaderMain');
        const lifestyleHeaders = document.querySelectorAll('.ctm-header');
        const tabs = document.querySelectorAll('.tab-btn');
        const brandToggles = document.querySelectorAll('.brand-toggle__btn, .drawer-brand-toggle__btn');
        const allToggleable = document.querySelectorAll('.tab-btn, .brand-toggle__btn, .drawer-brand-toggle__btn');
        const announcementBar = document.querySelector('.announcement-bar');

        function showHeader(type) {
          if (type === "swimwear") {
            lifestyleHeaders.forEach(el => el.style.display = 'none');
            swimwearHeaders.forEach(el => el.style.display = '');
          } else if (type === "lifestyle") {
            swimwearHeaders.forEach(el => el.style.display = 'none');
            lifestyleHeaders.forEach(el => el.style.display = '');
          }

          // Update active state on all tab/toggle elements
          allToggleable.forEach(el => {
            if (el.dataset.header === type) {
              el.classList.add("is-active");
              el.classList.add("active");
            } else {
              el.classList.remove("is-active");
              el.classList.remove("active");
            }
          });

          if (announcementBar) {
            if (type === "lifestyle") {
              announcementBar.classList.add("lifestyle-mode");
            } else {
              announcementBar.classList.remove("lifestyle-mode");
            }
          }
        }

        // Home page check
        const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.html';
        const savedHeader = isHomePage ? "swimwear" : (localStorage.getItem("activeHeader") || "swimwear");

        // Header show only once during page load
        showHeader(savedHeader);

        // Tab click: only update localStorage and active class
        tabs.forEach(tab => {
          tab.addEventListener("click", function () {
            const selected = this.dataset.header;
            localStorage.setItem("activeHeader", selected);
            tabs.forEach(t => t.classList.remove("is-active"));
            this.classList.add("is-active");
          });
        });

        // Brand toggle pill click: switch menus, persist, and optionally navigate
        brandToggles.forEach(btn => {
          btn.addEventListener("click", function () {
            const selected = this.dataset.header;
            const link     = this.dataset.link;

            localStorage.setItem("activeHeader", selected);
            showHeader(selected);

            // Navigate to the configured page if set and we're not already there
            if (link && link !== '#' && link !== '') {
              const targetPath = link.startsWith('http')
                ? new URL(link).pathname
                : link.split('?')[0];
              if (window.location.pathname !== targetPath) {
                window.location.href = link;
              }
            }
          });
        });
      });


document.addEventListener('DOMContentLoaded', function () {
  var trigger = document.querySelector('.desktop-search');
  if (!trigger) return;

  var activated = false;

  trigger.addEventListener('click', function () {
    if (activated) return;
    activated = true;

    document.querySelectorAll('img[data-src]').forEach(function (img) {
      // Fade-in once image is loaded
      img.addEventListener('load', function onLoad() {
        img.classList.add('loaded');
        img.removeEventListener('load', onLoad);
      });

      // Restore responsive attributes
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-srcset');
      }

      // Restore src
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });
  });
});



  (function ($) {
    if (!$) return;

    var TRANSITION_FALLBACK_MS = 350;

    function setTransitioning($drawer) {
      $drawer.addClass('is-transitioning');

      $drawer.one('transitionend webkitTransitionEnd oTransitionEnd', function () {
        $drawer.removeClass('is-transitioning');
      });

      setTimeout(function () {
        $drawer.removeClass('is-transitioning');
      }, TRANSITION_FALLBACK_MS);
    }

    function isOpen() {
      return $('html').hasClass('js-drawer-open') && $('#NavDrawer').hasClass('drawer--is-open');
    }

    function syncFabState(open) {
      var $fab = $('[data-mobile-drawer-toggle]').first();
      if (!$fab.length) return;

      $fab.toggleClass('is-open', !!open)
          .attr('aria-expanded', open ? 'true' : 'false')
          .attr('aria-label', open ? 'Close menu' : 'Open menu');
    }

    function openNavDrawer() {
      var $drawer = $('#NavDrawer');
      var $btn = $('.site-nav__link.site-nav__link--icon.js-drawer-open-nav').first();
      if (!$drawer.length) return;

      setTransitioning($drawer);

      requestAnimationFrame(function () {
        $('html').addClass('js-drawer-open lock-scroll');
        $drawer.addClass('drawer--is-open').attr('aria-hidden', 'false').attr('tabindex','-1');
        if ($btn.length) $btn.attr('aria-expanded', 'true');

        syncFabState(true);
        $drawer.focus();
      });
    }

    function closeNavDrawer() {
      var $drawer = $('#NavDrawer');
      var $btn = $('.site-nav__link.site-nav__link--icon.js-drawer-open-nav').first();
      if (!$drawer.length) return;

      setTransitioning($drawer);

      requestAnimationFrame(function () {
        $drawer.removeClass('drawer--is-open').attr('aria-hidden', 'true');
        $('html').removeClass('js-drawer-open lock-scroll');
        if ($btn.length) $btn.attr('aria-expanded', 'false');

        syncFabState(false);
      });
    }

    function toggleNavDrawer() {
      if (isOpen()) closeNavDrawer();
      else openNavDrawer();
    }

    // FAB toggles open/close
    $(document).on('click', '[data-mobile-drawer-toggle]', function (e) {
      e.preventDefault();
      toggleNavDrawer();
    });

    // Keep in sync when user closes via the drawer close button
    $(document).on('click', '#NavDrawer .js-drawer-close', function () {
      // allow theme handlers to run too; just sync after
      setTimeout(function () { syncFabState(false); }, 0);
    });

    // Close drawer when a nav link inside it is clicked
    $(document).on('click', '#NavDrawer a[href]', function () {
      var href = $(this).attr('href');
      // Don't close for anchor-only or javascript: links
      if (!href || href === '#' || href.indexOf('javascript:') === 0) return;
      setTimeout(function () { closeNavDrawer(); }, 50);
    });

    // Escape closes + sync
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) closeNavDrawer();
    });

    // Initial sync on load
    $(function () {
      syncFabState(isOpen());
    });

  })(window.jQuery);




(function () {
  const BTN_CLASS = 'itg-swatch-scroll-btn';
  const WRAP_CLASS = 'itg-swatch-scroll-wrap';
  const SCROLL_RATIO = 0.5;

  // Match your theme breakpoint here:
  const mql = window.matchMedia('(max-width: 768px)');

  function isMobile() {
    return mql.matches;
  }

  function ensureWrapper(swatches) {
    // Wrap swatches so the button can overlay without being clipped by overflow
    const parent = swatches.parentElement;
    if (!parent) return null;

    if (parent.classList.contains(WRAP_CLASS)) return parent;

    const wrap = document.createElement('div');
    wrap.className = WRAP_CLASS;

    parent.insertBefore(wrap, swatches);
    wrap.appendChild(swatches);

    return wrap;
  }

  function removeButton(wrap) {
    if (!wrap) return;
    const btn = wrap.querySelector('.' + BTN_CLASS);
    if (btn) btn.remove();
    // Optional: unwrap if you want (usually not necessary)
  }

  function shouldShowButton(swatches) {
    // Only show if there's actually overflow to scroll
    return swatches.scrollWidth > swatches.clientWidth + 4;
  }

  function atEnd(swatches) {
    return swatches.scrollLeft + swatches.clientWidth >= swatches.scrollWidth - 4;
  }

  function updateBtn(swatches, btn) {
    if (!shouldShowButton(swatches) || atEnd(swatches)) {
      btn.classList.add('is-hidden');
    } else {
      btn.classList.remove('is-hidden');
    }
  }

  function addButton(swatches) {
    if (!isMobile()) return;

    const wrap = ensureWrapper(swatches);
    if (!wrap) return;

    // If no overflow, no button needed
    if (!shouldShowButton(swatches)) {
      removeButton(wrap);
      return;
    }

    // Prevent duplicates
    let btn = wrap.querySelector('.' + BTN_CLASS);
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = BTN_CLASS;
      btn.setAttribute('aria-label', 'Scroll colors');

      btn.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      `;

      btn.addEventListener('click', () => {
        swatches.scrollBy({
          left: swatches.clientWidth * SCROLL_RATIO,
          behavior: 'smooth'
        });
      });

      wrap.appendChild(btn);

      // Keep button state in sync
      swatches.addEventListener('scroll', () => updateBtn(swatches, btn), { passive: true });
      window.addEventListener('resize', () => updateBtn(swatches, btn), { passive: true });
    }

    updateBtn(swatches, btn);
  }

  function init() {
    document.querySelectorAll('.c-swatches').forEach(swatches => {
      const wrap = swatches.closest('.' + WRAP_CLASS);

      if (!isMobile()) {
        // remove button on desktop
        if (wrap) removeButton(wrap);
        return;
      }

      addButton(swatches);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  mql.addEventListener('change', init);

  const observer = new MutationObserver(() => init());
  observer.observe(document.body, { childList: true, subtree: true });
})();

(function () {
  function hasFinePointer() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function bindZoomTarget(target) {
    if (!target || target.dataset.zoomBound === 'true') {
      return;
    }

    var image = target.querySelector('img');
    if (!image) {
      return;
    }

    target.dataset.zoomBound = 'true';
    target.classList.add('pdp-image-zoom');

    function setOrigin(evt) {
      var bounds = target.getBoundingClientRect();
      var xPercent = ((evt.clientX - bounds.left) / bounds.width) * 100;
      var yPercent = ((evt.clientY - bounds.top) / bounds.height) * 100;
      target.style.setProperty('--pdp-zoom-x', Math.min(100, Math.max(0, xPercent)) + '%');
      target.style.setProperty('--pdp-zoom-y', Math.min(100, Math.max(0, yPercent)) + '%');
    }

    target.addEventListener('mouseenter', function (evt) {
      if (!hasFinePointer()) return;
      setOrigin(evt);
      target.classList.add('is-zoomed');
    });

    target.addEventListener('mousemove', function (evt) {
      if (!hasFinePointer()) return;
      setOrigin(evt);
    });

    target.addEventListener('mouseleave', function () {
      target.classList.remove('is-zoomed');
    });

    image.addEventListener('click', function () {
      var zoomTrigger = target.querySelector('.js-photoswipe__zoom, [data-pdp-zoom-trigger]');
      if (zoomTrigger) {
        zoomTrigger.click();
      }
    });
  }

  function initPdpImageZoom(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-pdp-image-zoom-target]').forEach(bindZoomTarget);
  }

  window.NaniPdpImageZoom = window.NaniPdpImageZoom || {};
  window.NaniPdpImageZoom.init = initPdpImageZoom;

  document.addEventListener('DOMContentLoaded', function () {
    initPdpImageZoom(document);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    initPdpImageZoom(evt.target);
  });

  document.addEventListener('click', function (evt) {
    if (!evt.target.closest('.js-photoswipe__zoom')) return;
    if (typeof gtag === 'function') {
      gtag('event', 'pdp_image_zoom', {
        send_to: 'G-15KX0QWWZP'
      });
    }
  });
})();


document.addEventListener('click', function (e) {
  const btn = e.target.closest('.complete_the_fit_add');
  if (!btn) return;

  if (typeof gtag === 'function') {
    gtag('event', 'complete_the_fit_add_click', {
      send_to: 'G-15KX0QWWZP'
    });
    console.log('triggered and sent');
  }
});




(function () {
  function moneyFormatFromShopify(cents) {
    // If Shopify formatting is available, use it
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      // Most themes expose Shopify.money_format; fall back if missing
      var fmt = (window.theme && theme.moneyFormat) || (Shopify.money_format) || "${{amount}}";
      return Shopify.formatMoney(cents, fmt);
    }
    // Fallback: basic dollars
    return "$" + (cents / 100).toFixed(2);
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function getSubtotalFromDOM() {
    // Many drawer carts render a subtotal element you can scrape.
    // If your theme has a known selector for subtotal, add it here.
    // Return null to force /cart.js.
    return null;
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to fetch cart");
    return await res.json();
  }

  function updateWidget(root, subtotalCents) {
    // Promo mode: static banner, no threshold logic
    if (root.getAttribute("data-promo") === "true") return;

    const thresholdCents = parseInt(root.getAttribute("data-threshold"), 10) || 0;
    const titleTemplate = root.getAttribute("data-title-template") || "";
    const subtitle = root.getAttribute("data-subtitle") || "";

    const fill = root.querySelector("[data-free-ship-fill]");
    const titleEl = root.querySelector("[data-free-ship-title]");
    const subtitleEl = root.querySelector("[data-free-ship-subtitle]");
    const bar = root.querySelector(".CartFreeShip__bar");

    if (!thresholdCents || thresholdCents <= 0) return;

    const remaining = Math.max(0, thresholdCents - subtotalCents);
    const progress = clamp((subtotalCents / thresholdCents) * 100, 0, 100);

    // Title text
    if (remaining > 0) {
      const amount = moneyFormatFromShopify(remaining);
      const title = titleTemplate.includes("{{ amount }}")
        ? titleTemplate.replaceAll("{{ amount }}", amount)
        : titleTemplate;

      titleEl.textContent = title || `You’re ${amount} away from free shipping!`;
      if (subtitleEl) subtitleEl.textContent = subtitle;
    } else {
      titleEl.textContent = "You’ve unlocked FREE shipping!";
      if (subtitleEl) subtitleEl.textContent = "";
    }

    // Progress bar
    if (fill) fill.style.width = progress + "%";
    if (bar) bar.setAttribute("aria-valuenow", String(Math.round(progress)));
  }

  async function refreshAll() {
    const widgets = document.querySelectorAll("[data-free-ship]");
    if (!widgets.length) return;

    // Try DOM-derived subtotal first if you wire it up later
    let subtotalCents = getSubtotalFromDOM();

    if (subtotalCents == null) {
      try {
        const cart = await fetchCart();
        // Shopify cart.js: total_price includes discounts and is in cents
        // If you want pre-discount subtotal, use cart.original_total_price instead.
        subtotalCents = cart.total_price;
      } catch (e) {
        return;
      }
    }

    widgets.forEach((w) => updateWidget(w, subtotalCents));
  }

  // Initial
  document.addEventListener("DOMContentLoaded", refreshAll);

  // Refresh after common cart interactions (many themes trigger these)
  document.addEventListener("cart:updated", refreshAll);
  document.addEventListener("cart:refresh", refreshAll);

  // Catch fetch/XHR cart updates if theme doesn’t dispatch events:
  // Light-touch: refresh when drawer opens (Impulse often toggles a class)
  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest('[data-drawer-open], .js-drawer-open-cart, a[href="/cart"]');
    if (openBtn) setTimeout(refreshAll, 250);
  });

  // Also refresh on any add-to-cart submit
  document.addEventListener("submit", function (e) {
    const form = e.target;
    if (form && form.action && form.action.includes("/cart/add")) {
      setTimeout(refreshAll, 600);
    }
  });
})();

/* =============================================
   NANI FILTER SYSTEM — Search & Mobile Tabs
   ============================================= */
(function() {
  function initFilterSearch() {
    document.querySelectorAll('[data-filter-search]').forEach(function(input) {
      input.addEventListener('input', function() {
        var query = this.value.toLowerCase().trim();
        var grid = this.closest('.nani-filter-card__body').querySelector('.nani-swatch-grid');
        if (!grid) return;
        grid.querySelectorAll('.nani-swatch-item').forEach(function(item) {
          var label = (item.getAttribute('data-filter-label') || '').toLowerCase();
          item.style.display = label.indexOf(query) !== -1 ? '' : 'none';
        });
      });
    });
  }

  function applyActiveDrawerTab(tab) {
    /* Tabs are hidden — show all filter cards stacked */
    return;
  }

  function initFilterTabs() {
    document.querySelectorAll('.nani-filter-tabs').forEach(function(tabContainer) {
      var tabs = tabContainer.querySelectorAll('.nani-filter-tab');
      if (!tabs.length) return;

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          tabs.forEach(function(t) { t.classList.remove('nani-filter-tab--active'); });
          tab.classList.add('nani-filter-tab--active');
          applyActiveDrawerTab(tab);
        });
      });

      applyActiveDrawerTab(tabContainer.querySelector('.nani-filter-tab--active') || tabs[0]);
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initFilterSearch();
      initFilterTabs();
    });
  } else {
    initFilterSearch();
    initFilterTabs();
  }

  // Re-initialize after AJAX collection reload
  document.addEventListener('collection:reloaded', function() {
    initFilterSearch();
    initFilterTabs();
  });
})();


(function () {
  var param = new URLSearchParams(window.location.search).get('open');
  if (param !== 'saved') return;

  // Open the cart drawer
  document.dispatchEvent(new CustomEvent('cart:open'));

  // Wait for drawer to open and saved grid to render, then scroll
  var attempts = 0;
  var interval = setInterval(function () {
    var drawer = document.getElementById('CartDrawer');
    var target = drawer && drawer.querySelector('[data-cw-saved-grid]');
    if (target && target.offsetParent !== null) {
      clearInterval(interval);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (++attempts > 40) {
      clearInterval(interval);
    }
  }, 150);
})();

/* ── Klaviyo Back-in-Stock Notify ── */
(function () {
  // Track current variant ID from theme's variantChange events
  var currentVariantId = null;
  document.addEventListener('variant:change', function (e) {
    currentVariantId = e.detail && e.detail.variant ? String(e.detail.variant.id) : null;
  });

  // Toggle the "Your size sold out?" prompt form
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-klaviyo-prompt-toggle]');
    if (!toggle) return;
    var promptForm = toggle.closest('[data-klaviyo-notify-prompt]').querySelector('[data-klaviyo-prompt-form]');
    if (promptForm) {
      var isHidden = promptForm.style.display === 'none';
      promptForm.style.display = isHidden ? '' : 'none';
    }
  });

  document.addEventListener('keydown', function (e) {
    var emailInput = e.target.closest('[data-klaviyo-bis-email]');
    if (!emailInput || e.key !== 'Enter') return;

    var wrapper = emailInput.closest('[data-klaviyo-notify-form]') || emailInput.closest('[data-klaviyo-notify-prompt]');
    var submitBtn = wrapper && wrapper.querySelector('[data-klaviyo-bis-submit]');

    if (!submitBtn) return;

    e.preventDefault();
    submitBtn.click();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-klaviyo-bis-submit]');
    if (!btn) return;

    var wrapper = btn.closest('[data-klaviyo-notify-form]') || btn.closest('[data-klaviyo-notify-prompt]');
    var emailInput = wrapper.querySelector('[data-klaviyo-bis-email]');
    var msg = wrapper.querySelector('[data-klaviyo-bis-message]');
    var email = emailInput.value.trim();

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.textContent = 'Please enter a valid email address.';
      msg.style.display = '';
      msg.style.color = '#c00';
      return;
    }

    // Use variant ID captured from the theme's variantChange event
    var variantId = currentVariantId;
    if (!variantId) {
      var productForm = btn.closest('.product-single__form');
      var masterSelect = productForm && productForm.querySelector('[data-product-select]');
      if (masterSelect && masterSelect.value) {
        variantId = masterSelect.value;
      }
    }

    if (!variantId) {
      msg.textContent = 'Please select a size first.';
      msg.style.display = '';
      msg.style.color = '#c00';
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Submitting...';

    // Use Klaviyo's Back in Stock subscription endpoint
    var klaviyoCompanyId = null;
    // Extract the Klaviyo public key from the page's Klaviyo script
    var scripts = document.querySelectorAll('script[src*="klaviyo.com"]');
    scripts.forEach(function (s) {
      var match = s.src.match(/company_id=([^&"]+)/);
      if (match) klaviyoCompanyId = match[1];
    });

    if (!klaviyoCompanyId) {
      // Fallback: try the Klaviyo object
      if (window.klaviyo && window.klaviyo.account) {
        klaviyoCompanyId = window.klaviyo.account;
      }
    }

    if (!klaviyoCompanyId) {
      msg.textContent = 'Notification service unavailable. Please try again later.';
      msg.style.display = '';
      msg.style.color = '#c00';
      btn.disabled = false;
      btn.textContent = 'Notify Me';
      return;
    }

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + klaviyoCompanyId, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + variantId
              }
            }
          }
        }
      })
    }).then(function (res) {
      if (res.ok || res.status === 202) {
        msg.textContent = "You're in! We'll email you when this is back in stock.";
        msg.style.color = '#2a7d5f';
        emailInput.value = '';
      } else {
        msg.textContent = 'Something went wrong. Please try again.';
        msg.style.color = '#c00';
      }
      msg.style.display = '';
      btn.disabled = false;
      btn.textContent = 'Notify Me';
    }).catch(function () {
      msg.textContent = 'Something went wrong. Please try again.';
      msg.style.display = '';
      msg.style.color = '#c00';
      btn.disabled = false;
      btn.textContent = 'Notify Me';
    });
  });
})();

/* ================================================================
   NANI ENHANCED FILTER BAR — interactive behaviour
   ================================================================
   Responsibilities:
   1. Open / close filter dropdown panels via trigger buttons
   2. Close panels on outside-click or Escape key
   3. Submit filter form via AJAX on checkbox change (no page reload)
   4. Submit sort select change via AJAX
   5. Handle browser back / forward via popstate
   ================================================================ */
(function () {
  'use strict';

  // ── Panel helpers ─────────────────────────────────────────────

  function closeAllPanels() {
    document.querySelectorAll('[data-enhanced-filter-control].is-open').forEach(function (c) {
      c.classList.remove('is-open');
      var t = c.querySelector('[data-enhanced-filter-trigger]');
      var p = c.querySelector('[data-enhanced-filter-panel]');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (p) p.setAttribute('hidden', '');
    });
  }

  function openPanel(control) {
    var t = control.querySelector('[data-enhanced-filter-trigger]');
    var p = control.querySelector('[data-enhanced-filter-panel]');
    control.classList.add('is-open');
    if (t) t.setAttribute('aria-expanded', 'true');
    if (p) p.removeAttribute('hidden');
  }

  // ── AJAX grid load ────────────────────────────────────────────

  function loadGrid(url) {
    var grid = document.getElementById('CollectionAjaxContent');
    if (!grid) {
      window.location.href = url;
      return;
    }
    grid.style.transition = 'opacity .2s';
    grid.style.opacity = '0.4';
    grid.style.pointerEvents = 'none';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc   = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CollectionAjaxContent');
        if (fresh) {
          grid.innerHTML = fresh.innerHTML;
          grid.style.opacity = '1';
          grid.style.pointerEvents = '';
          document.dispatchEvent(new CustomEvent('collection:reloaded'));
        } else {
          window.location.href = url;
        }
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  // ── Scroll shadow on filter bar ──────────────────────────────
  (function () {
    var bar = document.querySelector('[data-enhanced-filter-bar]');
    if (!bar) return;
    function onScroll() {
      bar.classList.toggle('is-scrolled', window.scrollY > 10);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  // ── Event: trigger click (open / close panel) ─────────────────

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-enhanced-filter-trigger]');
    if (trigger) {
      var control = trigger.closest('[data-enhanced-filter-control]');
      if (!control) return;
      var isOpen = control.classList.contains('is-open');
      closeAllPanels();
      if (!isOpen) openPanel(control);
      return;
    }
    // Click outside the filter bar → close everything
    if (!e.target.closest('[data-enhanced-filter-bar]')) {
      closeAllPanels();
    }
  });

  // ── Event: Escape key ─────────────────────────────────────────

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPanels();
  });

  // ── Event: checkbox / sort change → AJAX ─────────────────────

  document.addEventListener('change', function (e) {

    // Filter checkbox inside the filter form
    var checkbox = e.target.closest('[data-enhanced-filter-form] .nani-enhanced-filter-option__input');
    if (checkbox) {
      // GA4 event: collection filter clicked
      if (typeof gtag === 'function') {
        var control = checkbox.closest('[data-enhanced-filter-control]');
        var filterGroup = control ? control.getAttribute('data-enhanced-filter-group') : '';
        var filterLabel = checkbox.closest('.nani-enhanced-filter-option');
        var filterValue = filterLabel ? (filterLabel.querySelector('.nani-enhanced-filter-option__name, .nani-coverage-card__name') || {}).textContent : '';
        gtag('event', 'collection_filter_click', {
          filter_group: filterGroup || '',
          filter_value: (filterValue || '').trim(),
          filter_action: checkbox.checked ? 'apply' : 'remove'
        });
      }

      var form   = checkbox.closest('[data-enhanced-filter-form]');
      var params = new URLSearchParams(new FormData(form));
      // Preserve current sort_by so it survives the filter change
      var currentSort = new URLSearchParams(window.location.search).get('sort_by');
      if (currentSort) params.set('sort_by', currentSort);
      var url = window.location.pathname + '?' + params.toString();
      history.pushState(null, '', url);
      loadGrid(url);
      return;
    }

    // Sort select (lives outside the form element)
    var sortSelect = e.target.closest('[data-enhanced-filter-bar] select[name="SortBy"]');
    if (sortSelect) {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortSelect.value);
      var url = window.location.pathname + '?' + params.toString();
      history.pushState(null, '', url);
      loadGrid(url);
    }
  });

  // ── Event: browser back / forward ────────────────────────────

  window.addEventListener('popstate', function () {
    loadGrid(window.location.pathname + window.location.search);
  });

})();

/* ================================================================
   COLLECTION GRID HOVER QUICK ADD
   ================================================================ */
(function () {
  'use strict';

  var SELECTORS = {
    card: '[data-collection-quick-add-card]',
    button: '[data-collection-quick-add-button]',
    status: '[data-collection-quick-add-status]'
  };

  var CART_ADD_URL = '/cart/add.js';
  var ERROR_HOLD_MS = 2200;
  var SUCCESS_HOLD_MS = 1800;

  function setStatus(card, message, state) {
    var el = card && card.querySelector(SELECTORS.status);
    if (!el) return;

    el.textContent = message || '';

    if (state) {
      el.setAttribute('data-state', state);
    } else {
      el.removeAttribute('data-state');
    }
  }

  function setCardActive(card, isActive) {
    if (!card) return;
    card.classList.toggle('is-active', !!isActive);
  }

  function refreshThemeCart() {
    try {
      document.dispatchEvent(new CustomEvent('cart:build'));
    } catch (e) {}

    try {
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (e) {}
  }

  function updateBubbleCount() {
    var getCart = window.theme && window.theme.cart && window.theme.cart.getCart;
    if (!getCart) return Promise.resolve();

    return getCart().then(function (cart) {
      var count = cart && cart.item_count;
      if (typeof count !== 'number') return;

      document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) {
        el.innerText = String(count);
      });

      document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
        bubble.classList.toggle('cart-link__bubble--visible', count > 0);
      });
    }).catch(function () {});
  }

  function addToCart(variantId) {
    return fetch(CART_ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    }).then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Could not add this size right now.');
        }

        return data;
      });
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(SELECTORS.button);
    if (!button) return;

    var card = button.closest(SELECTORS.card);
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.dataset.quickAddBusy === '1') return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) {
      setStatus(card, 'This size is unavailable.', 'error');
      setCardActive(card, true);
      return;
    }

    button.dataset.quickAddBusy = '1';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.remove('is-success');

    setCardActive(card, true);
    setStatus(card, 'Adding to cart...');

    addToCart(variantId)
      .then(function () {
        refreshThemeCart();
        return updateBubbleCount();
      })
      .then(function () {
        button.classList.add('is-success');
        setStatus(card, 'Added to cart.', 'success');

        window.setTimeout(function () {
          button.classList.remove('is-success');
          setStatus(card, '');
          setCardActive(card, false);
        }, SUCCESS_HOLD_MS);
      })
      .catch(function (error) {
        setStatus(card, (error && error.message) || 'Could not add this size right now.', 'error');
        window.setTimeout(function () {
          setStatus(card, '');
          setCardActive(card, false);
        }, ERROR_HOLD_MS);
      })
      .then(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.dataset.quickAddBusy = '0';
      });
  }, true);
})();

/* ================================================================
   MOBILE SIZE SELECTOR OVERLAY (Quick Add)
   ================================================================ */
(function () {
  'use strict';

  var CART_ADD_URL = '/cart/add.js';
  var SUCCESS_HOLD_MS = 1800;
  var ERROR_HOLD_MS = 2200;

  function setMobileStatus(overlay, message, state) {
    var el = overlay && overlay.querySelector('[data-mobile-size-status]');
    if (!el) return;
    el.textContent = message || '';
    if (state) {
      el.setAttribute('data-state', state);
    } else {
      el.removeAttribute('data-state');
    }
  }

  function openOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setMobileStatus(overlay, '');
  }

  function refreshThemeCart() {
    try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
  }

  function updateBubbleCount() {
    var getCart = window.theme && window.theme.cart && window.theme.cart.getCart;
    if (!getCart) return Promise.resolve();
    return getCart().then(function (cart) {
      var count = cart && cart.item_count;
      if (typeof count !== 'number') return;
      document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) {
        el.innerText = String(count);
      });
      document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
        bubble.classList.toggle('cart-link__bubble--visible', count > 0);
      });
    }).catch(function () {});
  }

  /* Open overlay when mobile ATC button is tapped */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-mobile-atc-trigger]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    var productId = trigger.getAttribute('data-product-id');
    var overlay = document.querySelector('[data-mobile-size-overlay][data-product-id="' + productId + '"]');
    openOverlay(overlay);
  });

  /* Close overlay — close button or backdrop tap */
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-mobile-size-close]')) {
      closeOverlay(event.target.closest('[data-mobile-size-overlay]'));
      return;
    }
    if (event.target.matches('[data-mobile-size-overlay]')) {
      closeOverlay(event.target);
    }
  });

  /* Add to cart from mobile overlay */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mobile-size-add]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.dataset.mobileBusy === '1') return;

    var overlay = button.closest('[data-mobile-size-overlay]');
    var variantId = button.getAttribute('data-variant-id');

    if (!variantId) {
      setMobileStatus(overlay, 'This size is unavailable.', 'error');
      return;
    }

    if (typeof gtag === 'function') {
      gtag('event', 'collection_quick_add_size_click', {
        send_to: 'G-15KX0QWWZP',
        product_id: (overlay && overlay.getAttribute('data-product-id')) || '',
        variant_id: variantId,
        size: (button.textContent || '').trim()
      });
    }

    button.dataset.mobileBusy = '1';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.remove('is-success');
    setMobileStatus(overlay, 'Adding to cart...');

    fetch(CART_ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Could not add this size right now.');
          return data;
        });
      })
      .then(function () {
        refreshThemeCart();
        return updateBubbleCount();
      })
      .then(function () {
        button.classList.add('is-success');
        setMobileStatus(overlay, 'Added to cart!', 'success');

        window.setTimeout(function () {
          button.classList.remove('is-success');
          closeOverlay(overlay);
        }, SUCCESS_HOLD_MS);
      })
      .catch(function (error) {
        setMobileStatus(overlay, (error && error.message) || 'Could not add this size right now.', 'error');
        window.setTimeout(function () {
          setMobileStatus(overlay, '');
        }, ERROR_HOLD_MS);
      })
      .then(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.dataset.mobileBusy = '0';
      });
  }, true);
})();

/* ================================================================
   EQUALIZE SWATCH ROW HEIGHTS ON MOBILE
   ================================================================ */
(function () {
  'use strict';

  var SELECTORS = ['.itg_color_option', '.grid-product__title', '.grid-product__price'];

  function equalizeGroup(selector) {
    var items = Array.from(document.querySelectorAll(selector));
    if (!items.length) return;

    /* Reset so we measure natural heights */
    items.forEach(function (el) { el.style.minHeight = ''; });

    /* Group items by visual row (same offsetTop on their product card) */
    var rows = {};
    items.forEach(function (el) {
      var card = el.closest('.grid__item');
      var top = card ? card.getBoundingClientRect().top : el.getBoundingClientRect().top;
      /* Round to nearest 5px to account for sub-pixel differences */
      var key = Math.round(top / 5) * 5;
      if (!rows[key]) rows[key] = [];
      rows[key].push(el);
    });

    /* Equalize within each row */
    Object.keys(rows).forEach(function (key) {
      var group = rows[key];
      if (group.length < 2) return;

      var max = 0;
      group.forEach(function (el) {
        var h = el.getBoundingClientRect().height;
        if (h > max) max = h;
      });

      if (max > 0) {
        group.forEach(function (el) { el.style.minHeight = max + 'px'; });
      }
    });
  }

  function equalize() {
    SELECTORS.forEach(equalizeGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', equalize);
  } else {
    equalize();
  }

  document.addEventListener('collection:reloaded', equalize);
  window.addEventListener('load', equalize);
  window.addEventListener('resize', equalize);
})();

/* ================================================================
   FILTER BAR SCROLL FADE HINT
   ================================================================ */
(function () {
  'use strict';

  function checkScroll(el) {
    var atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 4;
    el.classList.toggle('is-scrolled-end', atEnd);
  }

  function bindControls() {
    document.querySelectorAll('.nani-enhanced-filter-bar__controls').forEach(function (el) {
      if (el.dataset.fadeBound) return;
      el.dataset.fadeBound = '1';
      el.addEventListener('scroll', function () { checkScroll(el); }, { passive: true });
      checkScroll(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindControls);
  } else {
    bindControls();
  }

  document.addEventListener('collection:reloaded', bindControls);
})();


/* ================================================================
   COLLECTION GRID SWATCH IMAGE SWAP + PRODUCT GRID IMAGE SWIPE + DOTS
   ================================================================ */
(function () {
  'use strict';

  var SWIPE_THRESHOLD = 40;
  var TRANSITION_MS = 280;

  // Crossfade via a ghost overlay of the CURRENT image, while the underlying <img>
  // is swapped to the new URL after it has been decoded. The ghost hides any
  // blank/decoding frame so the user always sees a finished image.
  function slideImage(img, url, direction) {
    if (!img || !url) return;

    // Supersede any in-flight swap on this img
    if (img._swapToken) img._swapToken.cancelled = true;
    var token = { cancelled: false };
    img._swapToken = token;

    var preload = new Image();
    preload.decoding = 'async';
    preload.src = url;

    var ready = preload.decode
      ? preload.decode().catch(function () {})
      : new Promise(function (resolve) {
          if (preload.complete) return resolve();
          preload.onload = resolve;
          preload.onerror = resolve;
        });

    ready.then(function () {
      if (token.cancelled || img._swapToken !== token) return;
      var parent = img.parentNode;
      if (!parent) return;

      // Tear down any previous ghost still finishing its transition
      if (img._ghost && img._ghost.parentNode) {
        img._ghost.parentNode.removeChild(img._ghost);
      }

      // Clone current img attributes (preserves existing src/srcset so ghost shows old image)
      var ghost = img.cloneNode(false);
      ghost.removeAttribute('loading');
      ghost.removeAttribute('fetchpriority');
      ghost.removeAttribute('id');
      ghost.className = img.className + ' grid-product__image-ghost';
      ghost.style.cssText =
        'position:absolute;top:0;left:0;width:100%;height:100%;' +
        'object-fit:' + (getComputedStyle(img).objectFit || 'cover') + ';' +
        'pointer-events:none;z-index:2;opacity:1;transform:translateX(0);' +
        'transition:opacity ' + TRANSITION_MS + 'ms ease, transform ' + TRANSITION_MS + 'ms ease;' +
        'will-change:opacity,transform;';
      img._ghost = ghost;
      parent.appendChild(ghost);

      // Atomic swap on the underlying img. Clear srcset BEFORE src so the
      // browser doesn't re-pick a different candidate from the old srcset.
      img.srcset = '';
      img.sizes = '';
      if (img.dataset.src) img.dataset.src = url;
      img.src = url;

      // Force layout so the transition animates from the starting state
      void ghost.offsetWidth;

      ghost.style.opacity = '0';
      ghost.style.transform = 'translateX(' + (direction === 'left' ? '18%' : '-18%') + ')';

      var cleaned = false;
      var cleanup = function () {
        if (cleaned) return;
        cleaned = true;
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
        if (img._ghost === ghost) img._ghost = null;
      };
      ghost.addEventListener('transitionend', cleanup, { once: true });
      setTimeout(cleanup, TRANSITION_MS + 150);
    });
  }

  function setImage(mask, url, dotIndex, direction) {
    slideImage(mask.querySelector('img'), url, direction || 'right');
    mask.querySelectorAll('.grid-product__image-dot').forEach(function (d, i) {
      d.classList.toggle('is-active', i === dotIndex);
    });
    mask.dataset.activeIndex = dotIndex;
  }

  // ── Swatch tap: swap primary + secondary images, reset dots (mobile only) ──
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.itg_color_option .c-swatches-item');
    if (!swatch) return;

    // On desktop, let the link navigate normally
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    // Already active — allow navigation to PDP
    if (swatch.classList.contains('c-swatches-item-active')) return;

    var swapImage = swatch.dataset.swapImage;
    if (!swapImage) return;

    e.preventDefault();

    var card = swatch.closest('.grid__item');
    if (!card) return;
    var mask = card.querySelector('.grid-product__image-mask');

    // Swap primary image with slide-in animation
    if (mask) {
      slideImage(mask.querySelector('img'), swapImage, 'right');

      // Update mask data so swipe/dots reflect the new color's images
      mask.dataset.firstImage = swapImage;
      var secondImage = swatch.dataset.swapSecondImage || '';
      if (secondImage) {
        mask.dataset.secondImage = secondImage;
        mask.setAttribute('data-second-image', secondImage);
      } else {
        delete mask.dataset.secondImage;
        mask.removeAttribute('data-second-image');
      }

      // Reset dots to first image
      mask.querySelectorAll('.grid-product__image-dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === 0);
      });
      mask.dataset.activeIndex = '0';

      // Show/hide dots based on whether new color has a second image
      var dotsEl = mask.querySelector('.grid-product__image-dots');
      if (dotsEl) dotsEl.style.display = secondImage ? '' : 'none';

      // Keep the desktop hover image in sync
      var hoverImg = card.querySelector('.grid-product__secondary-image img');
      if (hoverImg && secondImage) {
        hoverImg.src = secondImage;
        hoverImg.srcset = '';
      }
    }

    // Update active swatch state
    swatch.closest('.c-swatches').querySelectorAll('.c-swatches-item').forEach(function (s) {
      s.classList.remove('c-swatches-item-active');
    });
    swatch.classList.add('c-swatches-item-active');

    // Reveal Shop CTA + pulse each tap
    var cta = card.querySelector('.swatch-shop-cta');
    if (cta) {
      cta.href = swatch.href;
      cta.textContent = 'Shop This Color';
      cta.removeAttribute('aria-hidden');
      cta.removeAttribute('tabindex');
      cta.classList.add('is-visible');
      cta.classList.remove('is-pulsing');
      void cta.offsetWidth;
      cta.classList.add('is-pulsing');
    }

    // Update ATC button + size overlay to match the swapped color's product
    var atcBtn = card.querySelector('[data-mobile-atc-trigger]');
    var sizeOverlay = card.querySelector('[data-mobile-size-overlay]');
    if (atcBtn && sizeOverlay) {
      var handle = swatch.href.split('/products/').pop().split('?')[0].split('#')[0];
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          atcBtn.dataset.productId = p.id;
          sizeOverlay.dataset.productId = p.id;

          // Find size option index
          var sizeIndex = 0;
          p.options.forEach(function (opt, i) {
            if (opt.toLowerCase().includes('size')) sizeIndex = i;
          });

          // Rebuild size buttons with new product's variants
          var sizeOptionsEl = sizeOverlay.querySelector('.grid-product__mobile-size-options');
          if (!sizeOptionsEl) return;
          var seen = {};
          var html = '';
          p.variants.forEach(function (v) {
            var val = v.options[sizeIndex];
            if (seen[val]) return;
            seen[val] = true;
            var avail = v.available;
            html += '<button type="button"' +
              ' class="grid-product__mobile-size-btn' + (avail ? '' : ' is-disabled') + '"' +
              (avail ? ' data-mobile-size-add data-variant-id="' + v.id + '"' : '') +
              (!avail ? ' disabled aria-disabled="true"' : '') +
              ' aria-label="' + (avail ? 'Add size ' + val + ' to cart' : val + ' unavailable') + '">' +
              val + '</button>';
          });
          sizeOptionsEl.innerHTML = html;
        })
        .catch(function () {}); // silently fail — worst case user lands on PDP via Shop CTA
    }
  });

  // ── Dot clicks ──
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.grid-product__image-dot');
    if (!dot) return;
    var mask = dot.closest('.grid-product__image-mask');
    if (!mask) return;
    var dots = Array.from(mask.querySelectorAll('.grid-product__image-dot'));
    var index = dots.indexOf(dot);
    var currentIndex = parseInt(mask.dataset.activeIndex || '0', 10);
    if (index === currentIndex) return;
    var url = index === 0 ? mask.dataset.firstImage : mask.dataset.secondImage;
    var direction = index > currentIndex ? 'right' : 'left';
    if (url) setImage(mask, url, index, direction);
  });

  // ── Swipe detection ──
  document.addEventListener('touchstart', function (e) {
    var mask = e.target.closest('.grid-product__image-mask[data-second-image]');
    if (!mask) return;
    mask.dataset.touchStartX = e.touches[0].clientX;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var mask = e.target.closest('.grid-product__image-mask[data-second-image]');
    if (!mask || mask.dataset.touchStartX === undefined) return;

    var delta = e.changedTouches[0].clientX - parseFloat(mask.dataset.touchStartX);
    delete mask.dataset.touchStartX;

    if (Math.abs(delta) < SWIPE_THRESHOLD) return;

    var currentIndex = parseInt(mask.dataset.activeIndex || '0', 10);
    var nextIndex = delta < 0 ? 1 : 0; // swipe left = next, swipe right = prev
    if (nextIndex === currentIndex) return;

    var url = nextIndex === 0 ? mask.dataset.firstImage : mask.dataset.secondImage;
    var direction = delta < 0 ? 'right' : 'left';
    if (url) setImage(mask, url, nextIndex, direction);
  }, { passive: true });
})();
